import React from 'react';
import GreenBoxComponent from '../../GreenBox';
import GreenBoxCustomerNamesLine from '../../GreenBoxCustomerNamesLine';
import {getGushHelkaTTHelkaRTLString} from '../../../utils/texts';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {getSelectedOptionLabel} from '../../../utils/options';
import styles from './styles.module.scss';

const GreenBox = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    streetName,
    houseNumber,
    cityName,
    gush, helka, ttHelka,
    rightsType,
    rightsOwnerName,
    identifyMethodType,
    joinHomeRegistryRightsType,
    propertyTypeName
  } = context.data.pdfData;

  const rightsTypeValue = getSelectedOptionLabel(rightsType, context.options.rightsTypeOptions);

 return (
   <GreenBoxComponent containerClassName={styles.containerGreenBox} ref={ref}>
     <div className={styles.blockLine}>
       {['הנדון:', propertyTypeName, "ברח'", streetName, `${houseNumber},`, cityName].filter(Boolean).join(' ')}
     </div>
     <div className={styles.blockLine}>
       גו"ח {getGushHelkaTTHelkaRTLString({gush, helka, ttHelka})}
     </div>
     <div className={styles.blockLine}>
       {[
         identifyMethodType === 2
           ? joinHomeRegistryRightsType ? ['זכויות', joinHomeRegistryRightsType] : ''
           : ['זכויות', rightsTypeValue],
         'ע"ש', rightsOwnerName,
       ].filter(Boolean).join(' ')
       }
     </div>
     <GreenBoxCustomerNamesLine />
   </GreenBoxComponent>
  )
});

export default GreenBox;
